// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Text } from '@mantine/core';
import { IconCalendar, IconCalendarEvent, IconFilter, IconMessageCircle } from '@tabler/icons';
import { FC, useContext } from 'react';
import { openModal } from '@mantine/modals';
import { useNavigate } from 'react-router-dom';
import CreateResourceModal from '../../../Organismns/Resources/CreateResouceModal';
import { ResourceAddonContext } from '../../../Service/Context/ResourceAddonsContext';
import { openAvailabilityModal } from '../../../Organismns/Resources/ResourceModals';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import ActionIconWithText from './ActionIconWithText';
import NavAddIcon from './NavAddIcon';

interface HandlersProps {
  filter: () => void;
}

const ResourcesPageFooter: FC<HandlersProps> = ({ filter }) => {
  const { openWidget } = useConversationsWidget();
  const navigate = useNavigate();
  const { executeWithCheck } = useContext(ResourceAddonContext);
  const { interceptViolation } = useContext(ViolationContext);

  const addResource = () => {
    executeWithCheck(() =>
      openModal({
        title: (
          <Text weight="bolder" size="xl">
            Ressource erstellen
          </Text>
        ),
        children: <CreateResourceModal interceptViolation={interceptViolation} />,
      }),
    );
  };

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Filter" onClick={filter}>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
        <IconCalendarEvent />
      </ActionIconWithText>
      <NavAddIcon onClick={addResource} />
      <ActionIconWithText useDefaultWidth label="Verfügbarkeit" onClick={() => executeWithCheck(openAvailabilityModal)}>
        <IconCalendar />
      </ActionIconWithText>
      <ActionIconWithText useDefaultWidth label="Support" onClick={openWidget}>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default ResourcesPageFooter;
